import { createElement } from 'react';

interface WeaveRadioButtonProps extends React.HTMLAttributes<HTMLInputElement> {
	disabled?: boolean;
	name?: string;
	value?: string;
}

export function WeaveRadioButton({ disabled, name, value, ...rest }: WeaveRadioButtonProps) {
	return createElement('weave-radio-button', { disabled, name, value, ...rest });
}
